import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {IEcommerceProduct} from "../../../ecommerce-product.interface";

@Component({
    selector: 'db-product-linked-products',
    templateUrl: './product-linked-products.component.html',
    styleUrls: ['./product-linked-products.component.scss'],
    standalone: false
})
export class ProductLinkedProductsComponent implements OnInit {
  @Input() linkedProductsForm: FormGroup;

  @Input() set products(prods: IEcommerceProduct[]) {
    this.allProducts = prods.map(prod => ({name: prod.name, id: prod.id}));
  };

  allProducts: { name: string; id: number }[] = [];

  constructor() {
  }

  ngOnInit() {
  }

}
